import styled from "styled-components";
import Link from "next/link";
import {breakpoints} from "@/styles/sizes";
import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import ForceSSRLink from "@/components/other/ForceSSRLink";

import BreadcrumbSeparatorIcon from '/public/images/br_path.svg';

const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  position: relative;
  flex-wrap: wrap;

  @media only screen and (${breakpoints.mobile}) {
    div:nth-child(1) {
      display: flex;
      align-items: center;
    }
`;

export const BreadcrumbsLinks = styled.div`
  display: flex;
  align-items: center;
  

  @media only screen and (${breakpoints.mobile}) {
    align-items: baseline;
  }
`;

const Links = styled.div`
  a {
    color: ${getColor('greenText')};
    font: ${({$small}) => ($small ? '14px' : '18px')} "Inter";
    text-decoration: none;
    white-space: nowrap;
  }
`;

const NoLinkItem = styled.div`
  color: ${getColor('greenText')};
  font: ${({$small}) => ($small ? '14px' : '18px')} "Inter";
  text-decoration: none;

  &:last-child {
    color: ${getColor('lightGreen')};
  }

  &:hover {
    text-decoration: underline;

    &:last-child {
      text-decoration: none;
    }
  }
`;

// `small` is the mobile variant, which sits under the hero in a smaller size.
export default function VariantBBreadcrumbs({ items, small = false }) {
  const separatorGap = small ? '6px' : '10px';

  return (
    <BreadcrumbsWrapper>
      {items &&
        items.map((item, index) => {
          if(!item){
        return;
      }
        return <BreadcrumbsLinks key={index}>
        {item?.link ? (
            //   <Links href={item.link}>{item.title}</Links>
            <Links $small={small}>
              {" "}
              <ForceSSRLink href={item.link}>{item.title}</ForceSSRLink>
            </Links>
        ) : (
            <NoLinkItem $small={small}>{item.title}</NoLinkItem>
        )}
        {index < items.length - 1 && <Image src={BreadcrumbSeparatorIcon} alt={'~'} style={{marginLeft:separatorGap, marginRight:separatorGap}}/>}
      </BreadcrumbsLinks>

})}
    </BreadcrumbsWrapper>
  );
}
